import { useNavigate, useParams } from 'react-router-dom';
import DeleteReviewButton from './DeleteReviewButton.js';
import { API_BASE } from '../../helper_methods/api.js';

/* receives the full review object as a prop (the profile page now fetches every review in one
query) instead of fetching itself by id, which used to cause one request per posted review */
export default function PostedReview({ review, setLoading }) {

    //USENAVIGATE HOOK
    let navigate = useNavigate();


    //CLICK FUNCTIONS
    const { userid } = useParams();
    const handleDeleteReview = async () => {
        setLoading(true)
        fetch(`${API_BASE}/profile/${userid}`, {
                method: 'post',
                credentials: 'include',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({request: "review-delete", reviewid: review._id, userid})
            })
        .then((response) => {
            setLoading(false)
            navigate(0)
        })
    }

    const handleClickReview = () => {
        navigate(`/courses/${review.courseCode}`)
    }


    //RETURNED COMPONENT
    return (
        <div className="profile-postedReview">
            {(review != null) ?
            <>
                <span className="profile-postedReview-bodycontainer">
                    <span className="profile-postedReview-titleAndIconFlexbox">
                        <h4 className="profile-postedReview-title" onClick={handleClickReview}>
                            {review.title}
                        </h4>
                        <DeleteReviewButton deletereview={handleDeleteReview}/>
                    </span>
                    <p>{review.courseCode.substring(0,2)}:{review.courseCode.substring(2,5)}:{review.courseCode.substring(5)}</p>
                </span>
            </>
            : null}
        </div>
    );
}
